import { ReactNode } from "react";
import Message from "@/Atoms/Messages/Message";

export default (
  {
    show,
    children
  }: {
    show?: boolean
    children: ReactNode
  }) => {

  if (show !== undefined && !show) {
    return <></>
  }
  return <Message type={'error'}>{children}</Message>
}
